module.exports = __webpack_public_path__ + "img/people.7c0fcdf1.svg";